/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Failure_Notification_TitleInputs */

const en_automation_failure_notification_title = /** @type {(inputs: Automation_Failure_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation failed`)
};

const pt_br2_automation_failure_notification_title = /** @type {(inputs: Automation_Failure_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na automação`)
};

/**
* | output |
* | --- |
* | "Automation failed" |
*
* @param {Automation_Failure_Notification_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_failure_notification_title = /** @type {((inputs?: Automation_Failure_Notification_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Failure_Notification_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_failure_notification_title(inputs)
	return pt_br2_automation_failure_notification_title(inputs)
});